import type {SeedQuestion, SeedQuestionSource, SeedQuestionStatus} from '@cp/model';
import updateSeedQuestionDoc from '../../api/seedQuestion/updateSeedQuestionDoc';
import {useFunctionWrap} from '../helper/function/useFunctionWrap';

export function useUpdateSeedQuestion() {
  const {
    fn: updateSeedQuestion,
    loading,
    error,
  } = useFunctionWrap(
    async (
      moduleId: string,
      seedQuestionId: string,
      questionText?: string,
      topic?: string,
      options?: string[],
      answer?: string,
      source?: SeedQuestionSource,
      status?: SeedQuestionStatus,
    ): Promise<SeedQuestion> =>
      updateSeedQuestionDoc(moduleId, seedQuestionId, {
        questionText,
        topic,
        options,
        answer,
        source,
        status,
      }),
  );

  return {
    updateSeedQuestion,
    loading,
    error,
  };
}
